export class ResponseClientSerproModel {
  public mensagem: string;
  public situacao: boolean;
  public inconsistencias: SerproInconsistenciesModelv2[];
}

export class SerproInconsistenciesModelv2 {
  public codigo: number;
  public descricao: string;
}

export enum SerproDocumentErrorCodesv2 {
  IRREGULAR_CPF_SITUATION = 11,
  INVALID_NAME = 12,
  INVALID_BIRTH_DATE = 13,
  INVALID_CPF = 14,
  INVALID_BIRTH_DATE_AGE_NOT_ALLOWED = 15,
  INVALID_BIRTH_DATE_INCORRECT_FORMAT = 16,
  //PJ
  INVALID_CNAE = 21,
  INVALID_OPEN_DATE = 22,
  CNPJ_NO_PARTNER = 23,
  INVALID_SOCIAL_REASON = 24,
  IRREGULAR_CNPJ_SITUATION = 25,
  //PARTNER
  partner_error = 31,
  partner_without_legal_representative = 32,
  partner_legal_representative_name_error = 33,
  partner_legal_representative_document_error = 34,
  partner_validate_social_reason_error = 35,
  minimun_age_partner = 41,
  //CONFIG
  MAX_ATTEMPTS_EXCEEDED = 51,
  //ERRORS
  COMMUNICATION_SERPRO_ERROR = 61,
  INTERNAL_SERPRO_ERROR = 62,
  unexpected_serpro_error = 63,
}
